import { render, staticRenderFns } from "./CopyrightDetails.vue?vue&type=template&id=797ec792"
import script from "./CopyrightDetails.vue?vue&type=script&lang=js"
export * from "./CopyrightDetails.vue?vue&type=script&lang=js"
import style0 from "./CopyrightDetails.vue?vue&type=style&index=0&id=797ec792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports